import React from 'react';

const sectionStyle = 'mb-8 max-w-3xl mx-auto';
const titleStyle = 'text-xl md:text-2xl font-bold text-[#4a4a3f] mb-4 text-center';
const listStyle = 'list-disc list-inside space-y-1 text-[#2f2f2f]';

const MarriageReg = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f6f6f2] p-4">
      <div className="w-full max-w-5xl  p-6 md:p-12 border  ">

        <h1 className="text-3xl md:text-4xl font-bold text-center text-[#333333] mb-10 border-b-2 pb-2 border-[#b7b7a1]">
          MARRIAGE REGISTRATION
        </h1>
        <p className="text-md text-justify text-[#444] mb-8">Our experienced staff is dedicated to assisting customers in the registration of marriages across all religions, ensuring a respectful and streamlined process that honors the diverse backgrounds of our clients. With the guidance of our expert lawyers, we provide comprehensive support from initial consultations to the final registration, making sure that all necessary documentation is accurately prepared and submitted in accordance with legal requirements. Our team understands the significance of marriage registration and strives to facilitate a smooth experience, addressing any concerns and answering questions along the way. By prioritizing client comfort and clarity, we empower couples to navigate the legalities of marriage with confidence, ensuring that their unions are officially recognized and protected under the law.</p>
        {/* Hindu Marriage Registration */}
        <section className={sectionStyle}>
          <h2 className={titleStyle}>Hindu Marriage Registration (Under Hindu Marriage Act, 1955)</h2>
          <ul className={listStyle}>
            <li>Application Form: Duly filled and signed by the bride and groom.</li>
            <li>Age Proof (Birth certificate, school leaving certificate, etc.)</li>
            <li>Address Proof (Aadhaar, Voter ID, Passport, etc.)</li>
            <li>Passport-sized Photographs</li>
            <li>Affidavit of Marital Status</li>
            <li>Witness Documents (At least 2 witnesses)</li>
            <li>Marriage Invitation Card (If available)</li>
            <li>Proof of Marriage (Photos, etc.)</li>
          </ul>
        </section>

        {/* Special Marriage Registration */}
        <section className={sectionStyle}>
          <h2 className={titleStyle}>Special Marriage Act Registration (Under Special Marriage Act, 1954)</h2>
          <ul className={listStyle}>
            <li>Application Form</li>
            <li>Age & Address Proof</li>
            <li>Passport-sized Photographs</li>
            <li>Affidavit of Marital Status</li>
            <li>Witness Documents (At least 3 witnesses)</li>
            <li>Notice of Intended Marriage (30-day display)</li>
            <li>Declaration by the Parties</li>
          </ul>
        </section>

        {/* Muslim Marriage Registration */}
        <section className={sectionStyle}>
          <h2 className={titleStyle}>Muslim Marriage Registration (Under Muslim Personal Law)</h2>
          <ul className={listStyle}>
            <li>Application Form</li>
            <li>Age & Address Proof</li>
            <li>Passport-sized Photographs</li>
            <li>Affidavit of Marital Status</li>
            <li>Witness Documents (At least 2 witnesses)</li>
            <li>Nikah Nama</li>
            <li>Qazi's Certificate</li>
          </ul>
        </section>

        {/* Christian Marriage Registration */}
        <section className={sectionStyle}>
          <h2 className={titleStyle}>Christian Marriage Registration (Under Indian Christian Marriage Act, 1872)</h2>
          <ul className={listStyle}>
            <li>Application Form</li>
            <li>Age & Address Proof</li>
            <li>Passport-sized Photographs</li>
            <li>Affidavit of Marital Status</li>
            <li>Witness Documents (At least 2 witnesses)</li>
            <li>Marriage Certificate from Church</li>
            <li>No Objection Certificate (If applicable)</li>
          </ul>
        </section>

        {/* Parsi Marriage Registration */}
        <section className={sectionStyle}>
          <h2 className={titleStyle}>Parsi Marriage Registration (Under Parsi Marriage and Divorce Act, 1936)</h2>
          <ul className={listStyle}>
            <li>Application Form</li>
            <li>Age & Address Proof</li>
            <li>Passport-sized Photographs</li>
            <li>Affidavit of Marital Status</li>
            <li>Witness Documents (At least 2 witnesses)</li>
            <li>Ashirvad Ceremony Certificate</li>
            <li>No Objection Certificate (If applicable)</li>
          </ul>
        </section>

        {/* General Notes */}
        <section className={sectionStyle}>
          <h2 className={titleStyle}>General Notes</h2>
          <ul className={listStyle}>
            <li><strong>Legal Advice:</strong> Our legal team ensures all documents are in order and meet the local registrar’s requirements.</li>
            <li>Ensure all documents are adequately verified to avoid delays or legal issues during registration.</li>
          </ul>
        </section>

      </div>
    </div>
  );
};

export default MarriageReg;
